import PropTypes from 'prop-types';
import React from 'react';

const resolve = obj => (obj && obj.__esModule ? obj.default : obj);

class LazilyLoad extends React.Component {
  state = {isLoaded: false};

  UNSAFE_componentWillMount() {
    this.load(this.props);
  }

  componentDidMount() {
    this._isMounted = true;
  }

  UNSAFE_componentWillReceiveProps(next) {
    if (next.modules === this.props.modules) return;
    this.load(next);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  load(props) {
    this.setState({
      isLoaded: false,
    });

    const {modules} = props;
    const keys = Object.keys(modules);

    Promise.all(keys.map(key => modules[key]().then(resolve)))
      .then(values =>
        keys.reduce((agg, key, index) => {
          agg[key] = values[index];
          return agg;
        }, {})
      )
      .then(result => {
        if (!this._isMounted) return;
        this.setState({modules: result, isLoaded: true});
      });
  }

  render() {
    if (!this.state.isLoaded) return null;
    return React.Children.only(this.props.children(this.state.modules));
  }
}

LazilyLoad.propTypes = {
  children: PropTypes.func.isRequired,
};

export const LazilyLoadFactory = (Component, modules) => {
  return props => (
    <LazilyLoad modules={modules}>
      {mods => <Component {...mods} {...props} />}
    </LazilyLoad>
  );
};

export default LazilyLoad;
